import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ResponsiveGrid } from '@adobe/aem-react-editable-components';
import { getBackgroundImageSrc, getIsKioskVersion } from '@yme/selectors/common';
import { GlobalKioskStyles } from '../../../GlobalStyled';
import { ScrollUpButton } from './components';
import { MainContainerStyled } from './styled';
export function MainContainer(props) {
    const location = useLocation();
    const backgroundImageSrc = useSelector(getBackgroundImageSrc) || '';
    const isKioskVersion = useSelector(getIsKioskVersion);
    const [bgUrl, setBgUrl] = useState(null);
    useEffect(() => {
        setBgUrl(location.pathname.includes('kiosk-landing') ? backgroundImageSrc : null);
    }, [location.pathname, backgroundImageSrc]);
    return (React.createElement(MainContainerStyled, { backgroundLink: bgUrl || undefined },
        isKioskVersion && React.createElement(GlobalKioskStyles, null),
        React.createElement(ResponsiveGrid, { ...props }),
        React.createElement(ScrollUpButton, null)));
}
MainContainer.displayName = 'MainContainer_Component';
